import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { ChaptersUpdateData } from '../../../types/chapters'
import { useApiPostMutation } from '../useApi'

export const useChaptersUpdate = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, ChaptersUpdateData>()

  return {
    ...mutation,
    mutateAsync: async (data: ChaptersUpdateData) => {
      const result = await mutation.mutateAsync({
        url: '/chapters/update',
        data,
      })
      queryClient.invalidateQueries({ queryKey: ['chapterList'] })
      return result
    },
    mutate: (data: ChaptersUpdateData) => {
      mutation.mutate(
        {
          url: '/chapters/update',
          data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['chapterList'] })
          },
        }
      )
    },
  }
}
